export default {
    currentUser(state){
        return state.auth.user
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js